export type InstrSurgeryIconName =
  | 'document'
  | 'calendar'
  | 'medical-bag'
  | 'cutlery'
  | 'medicine'
  | 'hanger'
  | 'headset'
  | 'download'
  | 'snowflake'
  | 'droplet'
  | 'capsules'
  | 'dental-care'
  | 'info'
  | 'brush-cleaning'
  | 'syringe'
  | 'shield-check'
  | 'no-smoking'
  | 'running';

const iconContent: Record<InstrSurgeryIconName, JSX.Element> = {
  // Lucide SVG paths; attribution is included in public/licenses/Lucide-LICENSE.txt.
  info: (
    <g fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M12 16v-4M12 8h.01" />
    </g>
  ),
  'brush-cleaning': (
    <g fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="m16 22-1-4" />
      <path d="M19 14a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2h-3a1 1 0 0 1-1-1V4a2 2 0 0 0-4 0v5a1 1 0 0 1-1 1H6a2 2 0 0 0-2 2v1a1 1 0 0 0 1 1" />
      <path d="M19 14H5l-1.973 6.767A1 1 0 0 0 4 22h16a1 1 0 0 0 .973-1.233zM8 22l1-4" />
    </g>
  ),
  syringe: (
    <g fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="m18 2 4 4m-5 1 3-3M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5m-6 6 4 4m-8 4-3 3M14 4l6 6" />
    </g>
  ),
  'shield-check': (
    <g fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
      <path d="m9 12 2 2 4-4" />
    </g>
  ),
  document: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6H6Zm8 2.5V8h3.5L14 4.5ZM8 11h8v1.5H8V11Zm0 4h8v1.5H8V15Zm0 4h5v1.5H8V19Z"
    />
  ),
  calendar: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2h2v2h8V2h2v2h1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1V2ZM5 9v11h14V9H5Z"
      />
      <path d="M7 11h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zm-8 4h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z" />
    </>
  ),
  'medical-bag': (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 3a2 2 0 0 0-2 2v2H5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3V5a2 2 0 0 0-2-2h-4Zm0 2h4v2h-4V5Zm1 5v3H8v2h3v3h2v-3h3v-2h-3v-3h-2Z"
    />
  ),
  cutlery: (
    <path d="M11 9H9V2H7v7H5V2H3v7a4 4 0 0 0 4 4v9h2v-9a4 4 0 0 0 4-4V2h-2v7Zm5-3v8h3v8h2V2a5 5 0 0 0-5 4Z" />
  ),
  medicine: (
    <>
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M5.5 2h5M8 2v3M4.5 5h7M5.5 5v8l2.5 2 2.5-2V5M8 15v4M5.5 8h2M5.5 11h2" />
      </g>
      <rect x="15.5" y="10.5" width="5" height="2.5" rx=".6" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 14h4l1.5 2v4.5A1.5 1.5 0 0 1 20 22h-4a1.5 1.5 0 0 1-1.5-1.5V16l1.5-2Zm1.3 2v1.3H16v1.4h1.3V20h1.4v-1.3H20v-1.4h-1.3V16h-1.4Z"
      />
    </>
  ),
  hanger: (
    <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 6a2 2 0 1 1 3.3 1.5C12.4 8.1 12 8.6 12 10" />
      <path d="m12 10-8.8 6a1 1 0 0 0 .6 1.8h16.4a1 1 0 0 0 .6-1.8L12 10Z" />
    </g>
  ),
  headset: (
    <>
      <path
        d="M3.5 13v-1.5a8.5 8.5 0 0 1 17 0V13M7 12v1a5 5 0 0 0 10 0v-1M20 16v2.5a1.5 1.5 0 0 1-1.5 1.5H15"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path d="M7 11.8c.4-3.7 2.8-5.4 5-5.4 3 0 5 2.2 5 5.2-2.5-.2-4.3-1.4-5.8-3.1-.6 1.6-2.3 2.8-4.2 3.3Z" />
      <rect x="2" y="11" width="3.5" height="6" rx="1.5" />
      <rect x="18.5" y="11" width="3.5" height="6" rx="1.5" />
      <rect x="11.5" y="18.8" width="4" height="2.4" rx="1.2" />
      <circle cx="9.7" cy="12.7" r=".65" />
      <circle cx="14.3" cy="12.7" r=".65" />
    </>
  ),
  download: (
    <path d="M11 3h2v8h4l-5 5-5-5h4V3ZM5 19h14v2H5v-2Z" />
  ),
  snowflake: (
    <path d="M22 11h-4.2l3.3-3.2-1.4-1.4L15 11h-2V9l4.7-4.7-1.4-1.4L13 6.2V2h-2v4.2L7.8 2.9 6.4 4.3 11 9v2H9L4.3 6.4 2.9 7.8 6.2 11H2v2h4.2l-3.3 3.2 1.4 1.4L9 13h2v2l-4.6 4.7 1.4 1.4 3.2-3.3V22h2v-4.2l3.3 3.3 1.4-1.4L13 15v-2h2l4.7 4.6 1.4-1.4-3.3-3.2H22v-2Z" />
  ),
  droplet: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C9.9 4.8 4.5 10.7 4.5 14.5a7.5 7.5 0 0 0 15 0C19.5 10.7 14.1 4.8 12 2ZM7 14a.8.8 0 0 0-.8.8 5.5 5.5 0 0 0 5.5 5.5.8.8 0 0 0 0-1.6 3.9 3.9 0 0 1-3.9-3.9A.8.8 0 0 0 7 14Z"
    />
  ),
  capsules: (
    <g fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6.3 17a5.4 5.4 0 0 1-1.6-8.7l5.7-5.7a5.4 5.4 0 0 1 7.6 7.6l-2.4 2.4M6.5 6.5l6 6" />
      <ellipse cx="14" cy="16.7" rx="8.2" ry="4.2" />
      <path d="M5.8 16.7v1.7a8.2 4.2 0 0 0 16.4 0v-1.7M8.5 19.8l10.2-6.2" />
    </g>
  ),
  'dental-care': (
    <g fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2.8 2.5h11v3h-11v-3ZM3.8 5.5l.8 13H12l.8-13M5 18.5V22h6v-3.5M17.5 3H22v7h-4.5V3ZM17.5 10v10.5a1.5 1.5 0 0 0 3 0V10M20 3v7M20 5.3h2M20 7.7h2" />
      <path
        d="M8.3 8.8c-1.2-1.5-3.5-.7-3.1 1.2.3 1.4.8 2.5 1.1 4.2.2 1 .9 1 1.2.1l.8-2 .8 2c.3.9 1 .9 1.2-.1.3-1.7.8-2.8 1.1-4.2.4-1.9-1.9-2.7-3.1-1.2Z"
        strokeWidth="1.2"
      />
    </g>
  ),
  'no-smoking': (
    <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2.5 15.5h9M2.5 18h11.8M2.5 15.5V18M17.5 15.5H22V18h-2M19 15.5V18M17.5 12.5v-1.8c0-2.2-3.4-2.1-3.4-4.4 0-1.2.8-2 2.1-2.1M21.5 12.5V10c0-3.8-3.1-3.1-3.1-5.7 0-.8.4-1.5 1.1-1.9M3 3l18 18" />
    </g>
  ),
  running: (
    <>
      <circle cx="14" cy="3.5" r="2" />
      <path d="m10.5 7.3-4.5 1.7v5h2v-3.6l2-.8-1.8 8.1-5-1-.4 2 6.1 1.4c.9.2 1.7-.4 1.9-1.2l.9-3.9 2.3 2.1V23h2v-7l-2.7-2.5.7-3.5c1.4 1.8 3.3 2.9 5.7 2.9v-2c-2 0-3.5-1.1-4.4-2.6l-.9-1.5a2 2 0 0 0-2.5-.8l-1.4.6Z" />
    </>
  ),
};

export function InstrSurgeryIcon({
  name,
  className = 'h-5 w-5',
}: {
  name: InstrSurgeryIconName;
  className?: string;
}) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true" focusable="false">
      {iconContent[name]}
    </svg>
  );
}
